import { gql } from '@apollo/client';

const GET_EVALUATION_EVENT_MUTATION = gql`
  mutation getEvaluationEvent($studyId: ID!) {
    getEvaluationEvent(studyId: $studyId) {
      isSuccess
      message
    }
  }
`;

export default GET_EVALUATION_EVENT_MUTATION;
